// @flow

import holdFormatter from './hold.formatter';
import groupFormatter from '../../../formatters/group.formatter';
import type { FormatterArgs } from '../../../types';
import alloFormatter from './alloFormatter'

const formatters = (args?: FormatterArgs): Array<any> =>
  [alloFormatter, holdFormatter, groupFormatter].map(formatter => formatter(args));

export default formatters;
